import React from 'react';
import { CardWrapper } from './Theme'
export const Card = ({ style, children }) => {
    return (
        <CardWrapper style={style}>
            {children}
        </CardWrapper>
    );
};
